import {
    BEST_DAYS_TO_VISIT_OPTIONS,
    BEST_TIME_TO_CONTACT_OPTIONS,
    VisitPreferenceOption,
} from "@sp-crm/core";
import { InputFormBlock } from "components/app/input-form-block";
import { Header } from "components/header";
import { ButtonSelect, ButtonSelectOption } from "components/ui/button-select";
import React, { useCallback } from "react";

const toButtonSelectOption = (option: VisitPreferenceOption): ButtonSelectOption => ({
    id: option.value,
    label: option.label,
});

export const bestDaysToVisitOptions: ButtonSelectOption[] =
    BEST_DAYS_TO_VISIT_OPTIONS.map(toButtonSelectOption);

const bestTimeToContactOptions: ButtonSelectOption[] =
    BEST_TIME_TO_CONTACT_OPTIONS.map(toButtonSelectOption);

const toggled = (values: string[], id: string): string[] =>
    values.includes(id) ? values.filter(value => value !== id) : [...values, id];

interface PreferenceGroupProps {
    label: string;
    options: ButtonSelectOption[];
    values: string[];
    onChange: (newValues: string[]) => void;
}

const PreferenceGroup: React.FC<PreferenceGroupProps> = props => {
    const { label, options, values, onChange } = props;

    const handleToggle = useCallback(
        (id: string) => onChange(toggled(values, id)),
        [values, onChange],
    );

    return (
        <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                {label}
            </p>
            <ButtonSelect
                options={options}
                selectedIds={values}
                onToggle={handleToggle}
            />
        </div>
    );
};

interface VisitPreferencesPanelProps {
    bestDaysToVisit: string[];
    bestTimeToContact: string[];
    onBestDaysToVisitChange: (newValues: string[]) => void;
    onBestTimeToContactChange: (newValues: string[]) => void;
}

export const VisitPreferencesPanel: React.FC<VisitPreferencesPanelProps> = props => {
    const {
        bestDaysToVisit,
        bestTimeToContact,
        onBestDaysToVisitChange,
        onBestTimeToContactChange,
    } = props;

    return (
        <InputFormBlock>
            <Header>Visit Preferences</Header>
            <div className="flex flex-col gap-3 pt-2">
                <PreferenceGroup
                    label="Best days to visit"
                    options={bestDaysToVisitOptions}
                    values={bestDaysToVisit}
                    onChange={onBestDaysToVisitChange}
                />
                <PreferenceGroup
                    label="Best time to contact"
                    options={bestTimeToContactOptions}
                    values={bestTimeToContact}
                    onChange={onBestTimeToContactChange}
                />
            </div>
        </InputFormBlock>
    );
};
